import Auth0PropWrapper from './component'
export default Auth0PropWrapper
